import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";
import { FileType } from "../../../Components/HomePage/FileTypeSelector/FileTypeSelector";

export type InitialStateTypes = {
  fileType: FileType | null;
  loading: boolean;
};

const initialState = {
  fileType: null,
  loading: false,
} as InitialStateTypes;

export const selectedFileType = createSlice({
  name: "selectedFileType",
  initialState,
  reducers: {
    setFileType: (state, action: PayloadAction<FileType>) => {
      state.loading = true;
      state.fileType = action.payload;
    },
    resetFileType: (state) => {
      state.fileType = null;
    },
    setSelectedFileTypeLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setFileType, resetFileType, setSelectedFileTypeLoading } =
  selectedFileType?.actions || {};
export default selectedFileType.reducer;

export const useSelectedFileType = () => {
  const dispatch = useAppDispatch();
  const { fileType, loading } = useAppSelector((state) => state.selectedFileType);

  const dispatchSetSelectFileType = useCallback(
    (data: FileType) => {
      dispatch(setFileType(data));
    },
    [dispatch],
  );
  const dispatchSetSelectFileTypeLoading = useCallback(
    (data: boolean) => {
      dispatch(setSelectedFileTypeLoading(data));
    },
    [dispatch],
  );

  return {
    fileType,
    dispatchSetSelectFileType,
    loading,
    dispatchSetSelectFileTypeLoading,
  };
};
